import { Disease, FunctionalStatus } from "@domain/medical-condition/medical-condition";

import { Dayjs } from "dayjs";

interface InvitationSummary {
	invitingPt: PtNameOutput;
	message?: string;
}

interface PtNameOutput {
	firstName: string;
	lastName: string;
}

export interface PatientSummary {
	id: string;
	analyticsId: string;
	firstName?: string;
	lastName?: string;
	birthDate?: Dayjs;
	creationDate: Dayjs;
	disease?: Disease;
	functionalStatus?: FunctionalStatus;
}

export interface SharePatientOutput {
	invitation: InvitationSummary;
	patient: PatientSummary;
}

export interface RegisteredPtInviteData {
	firstName: string;
	lastName: string;
	email: string;
	analyticsId: string;
}

export interface UnregisteredPtInviteData {
	email: string;
	invitationId: string;
}

interface BaseHealthcareTeamMember {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	status: HealthcareTeamMemberStatus;
}

export interface RegisteredHealthcareTeamMember extends BaseHealthcareTeamMember {
	ptId: string;
	ptAnalyticsId: string;
}

export interface UnregisteredHealthcareTeamMember extends BaseHealthcareTeamMember {
	ptId?: string;
	ptInvitationId: string;
}

export interface HealthcareTeam {
	patientId: string;
	healthcareTeamMembers: HealthcareTeamMember[];
}

export type HealthcareTeamMember = RegisteredHealthcareTeamMember | UnregisteredHealthcareTeamMember;

export enum HealthcareTeamMemberStatus {
	PendingPTRegistration = "PENDING_PT_REGISTRATION",
	PendingPatientValidation = "PENDING_PATIENT_VALIDATION",
	PendingPtValidation = "PENDING_PT_VALIDATION",
	Confirmed = "CONFIRMED",
}

export function isUnregisteredHealthcareTeamMember(
	member: HealthcareTeamMember,
): member is UnregisteredHealthcareTeamMember {
	return member.status === HealthcareTeamMemberStatus.PendingPTRegistration;
}

export function isRegisteredHealthcareTeamMember(
	member: HealthcareTeamMember,
): member is RegisteredHealthcareTeamMember {
	return !isUnregisteredHealthcareTeamMember(member);
}
